import { Reveal } from "./Reveal";

const STEPS = [
  { n: "1", title: "Capture", body: "Speak naturally. Voice-to-text turns calls, deal notes, and insights into structured input without breaking your flow." },
  { n: "2", title: "Structure & Score", body: "Artifacts are created and scored so high-value knowledge surfaces first." },
  { n: "3", title: "Coach & Mature", body: "A conversational coach focused on sales motions asks targeted questions, drawing on relevant context and frontier AI models to sharpen and expand your artifacts for future use." },
  { n: "4", title: "Serve", body: "Only the relevant, scored slice is injected into AI — ready when you need it to win deals." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="relative py-12 md:py-20 border-t border-white/[0.05]" data-testid="how-it-works-section">
    <div className="mx-auto max-w-[1240px] px-6 md:px-12">
      <Reveal>
        <p className="text-sm font-medium tracking-widest uppercase text-teal mb-5">How it works</p>
        <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-50 max-w-3xl leading-[1.08]">
          How SalesMoat works
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-400">
          Voice capture + a sales-focused coach that helps you curate and strengthen your IP over time.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        <Reveal className="lg:sticky lg:top-28">
          <div className="relative rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-transparent p-3 shadow-[0_20px_60px_rgba(0,0,0,0.35)]">
            <img
              src="/assets/ip_cycle.jpg"
              alt="SalesMoat IP Cycle: Capture, Structure & Score, Coach & Mature, Serve"
              className="w-full rounded-2xl"
              data-testid="ip-cycle-image"
            />
          </div>
        </Reveal>

        <div className="flex flex-col">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div
                className="group flex gap-5 md:gap-6 py-6 border-b border-white/[0.06] last:border-b-0"
                data-testid={`how-step-${s.n}`}
              >
                <span className="flex-shrink-0 flex h-11 w-11 items-center justify-center rounded-full border border-teal/30 bg-teal/[0.08] font-heading text-lg font-semibold text-teal transition-colors duration-300 group-hover:bg-teal group-hover:text-navy">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-heading text-xl font-medium text-slate-100">{s.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-slate-400">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
